/**
 * Monte sua lista — Focus Uniformes SP
 * Cards do fluxo disponíveis em todo o site (launcher no header); a página renderiza a etapa de produtos.
 * Preço e estoque dos itens da lista são revalidados contra /products/{handle}.js.
 * Eventos de interação vão para window.dataLayer com o prefixo msl_ (GTM).
 */
(function () {
  'use strict';

  const app = document.querySelector('[data-msl-app]');
  if (!app) return;
  if (app.parentElement !== document.body) document.body.appendChild(app);
  if (document.querySelector('.msl')) document.documentElement.classList.add('msl-page');
  const root = document.querySelector('.msl');            // seção da página (pode não existir)
  const onPage = !!root;

  // ---------- Config ----------
  const CFG = JSON.parse(app.querySelector('[data-msl-config]').textContent);
  if (onPage) {
    const override = root.querySelector('[data-msl-config]');
    if (override) {
      try { Object.assign(CFG.texts, JSON.parse(override.textContent).texts || {}); } catch (e) { /* ignore */ }
    }
  }
  const T = CFG.texts;
  const TEXT_FALLBACK = {
    linked: 'ADICIONADO',
    outOfStock: 'SEM ESTOQUE',
    notAdded: 'NÃO ADICIONADO',
    soldOutTitle: 'PRODUTO ESGOTADO',
    soldOutText: 'Infelizmente o estoque do produto que escolheu esgotou enquanto criava sua lista. Mas não se preocupe, temos outras opções que irão suprir sua necessidade!',
    soldOutReplace: 'ADICIONAR OUTRO PRODUTO',
    soldOutSkip: 'SEGUIR SEM O PRODUTO',
    prevLabel: 'Voltar',
    nextLabel: 'Avançar',
    variantRequired: 'Selecione uma opção para adicionar à lista',
    variantOnCard: 'Escolha a opção desejada no card do produto para adicionar à lista.'
  };
  Object.keys(TEXT_FALLBACK).forEach((k) => { if (!T[k]) T[k] = TEXT_FALLBACK[k]; });
  if (/vinculado/i.test(T.linked)) T.linked = TEXT_FALLBACK.linked;
  const PAGE_URL = app.dataset.pageUrl || '/pages/monte-sua-lista';
  const CARD_STYLE = app.dataset.cardStyle || 'standard';
  const CARD_SCHEME = app.dataset.cardScheme || '';
  const BASE_COLLECTION = (onPage && root.dataset.baseCollection) || app.dataset.baseCollection || 'material';
  const WHATSAPP = ((onPage && root.dataset.whatsapp) || app.dataset.whatsapp || '').replace(/\D/g, '');
  const EMAIL_TO = (onPage && root.dataset.email) || app.dataset.email || '';
  const OPEN_DRAWER = ((onPage && root.dataset.cartDrawer) || app.dataset.cartDrawer) !== 'false';
  const STORAGE = 'msl_state_v1';
  const BALANCE_KEY = 'msl_balance';

  CFG.lists = (CFG.lists || []).sort((a, b) => (a.order || 0) - (b.order || 0));
  CFG.ownCategories = (CFG.ownCategories || []).sort((a, b) => (a.order || 0) - (b.order || 0));

  // ---------- DOM ----------
  const $ = (s, el) => (el || document).querySelector(s);
  const pick = (sel) => (onPage ? root.querySelector(sel) : null);
  const el = {
    status: pick('[data-msl-status]'),
    filters: pick('[data-msl-filters]'),
    grid: pick('[data-msl-grid]'),
    summary: pick('[data-msl-summary]'),
    catbar: pick('[data-msl-catbar]'),
    chips: pick('[data-msl-chips]'),
    prev: pick('[data-msl-prev]'),
    next: pick('[data-msl-next]'),
    fabs: pick('[data-msl-fabs]'),
    count: pick('[data-msl-count]'),
    drawer: pick('[data-msl-drawer]'),
    items: pick('[data-msl-items]'),
    totals: pick('[data-msl-totals]'),
    sort: pick('[data-msl-sort]'),
    overlay: app.querySelector('[data-msl-overlay]'),
    card: app.querySelector('[data-msl-card]'),
    loading: app.querySelector('[data-msl-loading]'),
    loadingText: app.querySelector('[data-msl-loading-text]')
  };

  // ---------- State ----------
  const state = load() || {
    mode: null,
    listHandle: null,
    step: 0,
    catSlug: null,
    balance: null,
    items: [],
    skipped: [],
    summary: false,
    pendingConfirm: false
  };
  const productsCache = {};
  let currentProducts = [];
  let filterValues = { categoria: '', idade: '', genero: '', cor: '', marca: '', extra: '' };
  let sortValue = 'added';
  let drawerTab = 'list';   // aba ativa do painel: 'list' ou 'check'

  // Variante escolhida no card, por produto. Não persiste: a escolha é sempre
  // explícita a cada visita, para o usuário nunca adicionar uma variante por engano.
  const selectedVariants = {};
  function variantsOf(p) { return (p && p.variants) || []; }
  function isMultiVariant(p) { return variantsOf(p).length > 1; }
  function selectedVariantOf(p) {
    if (!isMultiVariant(p)) return variantsOf(p)[0] || null;
    const id = selectedVariants[p.id];
    if (id == null) return null;
    return variantsOf(p).find((v) => String(v.id) === String(id)) || null;
  }

  function load() {
    try { return JSON.parse(localStorage.getItem(STORAGE)); } catch (e) { return null; }
  }
  function save() { localStorage.setItem(STORAGE, JSON.stringify(state)); }

  // ---------- Helpers ----------
  const money = (v) => 'R$' + (Number(v) || 0).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  const fmt = (tpl, map) => String(tpl || '').replace(/[{\[](\w+)[}\]]/g, (_, k) => map[k] != null ? map[k] : '');

  function currentList() { return CFG.lists.find((l) => l.handle === state.listHandle) || null; }
  function currentSteps() { const l = currentList(); return l ? l.items.filter((i) => i.category) : []; }
  function currentCategory() {
    if (state.mode === 'city') { const s = currentSteps()[state.step]; return s ? s.category : null; }
    if (state.mode === 'own') { return CFG.ownCategories.find((c) => c.slug === state.catSlug) || CFG.ownCategories[0] || null; }
    return null;
  }
  function currentQtyDefault() { return 1; }
  function itemsOfCat(slug) { return state.items.filter((i) => i.cat === slug); }
  function stepDone(slug) { return itemsOfCat(slug).length > 0; }
  function stepEmpty(slug) { return (state.skipped || []).includes(slug) && !stepDone(slug); }
  function stepState(slug) { return stepDone(slug) ? 'done' : stepEmpty(slug) ? 'empty' : 'todo'; }
  function total() { return state.items.reduce((a, i) => a + i.price * i.qty, 0); }
  function toast(msg) {
    const t = document.createElement('div'); t.className = 'msl-toast'; t.textContent = msg;
    document.body.appendChild(t); setTimeout(() => t.remove(), 2600);
  }

  // ---------- Datalayer (GTM) ----------
  // Todo evento leva o prefixo msl_ para não colidir com o que o tema já dispara,
  // e carrega o contexto do fluxo para dispensar variáveis extras no GTM.
  function dl() { window.dataLayer = window.dataLayer || []; return window.dataLayer; }
  function flowName() { return state.mode === 'city' ? 'prefeitura' : state.mode === 'own' ? 'conta_propria' : null; }
  function trackContext() {
    const l = currentList();
    const cat = currentCategory();
    const steps = currentSteps();
    return {
      msl_fluxo: flowName(),
      msl_lista: l ? l.handle : null,
      msl_lista_nome: l ? l.name : null,
      msl_saldo: state.balance,
      msl_categoria: cat ? cat.slug : null,
      msl_categoria_nome: cat ? cat.name : null,
      msl_etapa: state.mode === 'city' ? state.step + 1 : null,
      msl_etapas_total: state.mode === 'city' ? steps.length : null,
      msl_itens: state.items.reduce((a, i) => a + i.qty, 0),
      msl_valor_lista: round2(total()),
      // Sem depender de isMobile(), que só existe mais abaixo no arquivo
      msl_dispositivo: (window.matchMedia && window.matchMedia('(max-width:989px)').matches) ? 'mobile' : 'desktop'
    };
  }
  function round2(v) { return Math.round((Number(v) || 0) * 100) / 100; }
  // Tracking nunca pode derrubar o fluxo do usuário
  function track(event, data) {
    try { dl().push(Object.assign({ event: event }, trackContext(), data || {})); } catch (e) { /* ignore */ }
  }
  // Eventos com produto usam o formato de ecommerce do GA4, prontos para mapear no GTM
  function trackEcom(event, value, items, data) {
    try {
      dl().push({ ecommerce: null });
      dl().push(Object.assign({ event: event }, trackContext(), {
        ecommerce: { currency: 'BRL', value: round2(value), items: items || [] }
      }, data || {}));
    } catch (e) { /* ignore */ }
  }
  function itemPayload(it) {
    return {
      item_id: String(it.variantId),
      item_name: it.title,
      item_category: it.cat || undefined,
      price: round2(it.price),
      quantity: it.qty
    };
  }

  // ---------- Saldo ----------
  // O saldo pertence ao fluxo ativo. Valor não positivo limpa a chave persistida
  // para que um fluxo anterior nunca seja reaproveitado.
  function setBalance(value) {
    const v = Number(value);
    state.balance = isNaN(v) ? null : v;
    if (v > 0) localStorage.setItem(BALANCE_KEY, String(v));
    else { try { localStorage.removeItem(BALANCE_KEY); } catch (e) { /* ignore */ } }
    save();
    // Redesenha tudo que mostra saldo (status, painel da lista, resumo)
    renderBalanceViews();
  }
  // Zera o saldo ao trocar de fluxo, antes de aplicar o do fluxo novo
  function resetBalance() {
    state.balance = null;
    try { localStorage.removeItem(BALANCE_KEY); } catch (e) { /* ignore */ }
    save();
  }
  function readBarBalance() {
    const v = parseFloat(localStorage.getItem(BALANCE_KEY));
    return isNaN(v) ? null : v;
  }
  // O saldo aparece em três lugares; todos precisam ser redesenhados juntos
  function renderBalanceViews() {
    if (!onPage) return;
    renderStatus();
    renderList();
    if (state.summary) renderSummary();
  }

  // ---------- Produtos ----------
  async function fetchCollection(handle) {
    if (productsCache[handle]) return productsCache[handle];
    const all = [];
    for (let page = 1; page <= 4; page++) {
      const res = await fetch(`/collections/${handle}/products.json?limit=250&page=${page}`);
      if (!res.ok) break;
      const data = await res.json();
      const list = data.products || [];
      all.push(...list);
      if (list.length < 250) break;
    }
    productsCache[handle] = all;
    return all;
  }

  async function fetchProduct(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      return await res.json();
    } catch (e) { return null; }
  }

  async function refreshItems() {
    const handles = [...new Set(state.items.map((i) => i.handle).filter(Boolean))];
    if (!handles.length) return;
    const results = await Promise.all(handles.map(fetchProduct));
    const byHandle = {};
    handles.forEach((h, i) => { byHandle[h] = results[i]; });
    state.items.forEach((it) => {
      const p = byHandle[it.handle];
      if (!p) return;
      const v = (p.variants || []).find((x) => x.id === it.variantId);
      if (!v) { it.soldOut = true; return; }
      it.price = parseFloat(v.price) / 100;
      it.soldOut = !v.available;
    });
    save();
  }

  function isKit(p) {
    const rx = /(^|[^a-z])kits?([^a-z]|$)/;
    if (rx.test(norm(p.title)) || rx.test(norm(p.product_type)) || rx.test(norm(p.vendor))) return true;
    return (p.tags || []).some((t) => rx.test(norm(t)));
  }

  function pickVariant(product, hint) {
    const vs = product.variants || [];
    if (hint) {
      const h = norm(hint);
      const v = vs.find((x) => norm(x.title).includes(h) || [x.option1, x.option2, x.option3].some((o) => norm(o) === h));
      if (v) return v;
    }
    return vs.find((v) => v.available) || vs[0] || null;
  }

  async function productsForCategory(cat) {
    if (!cat) return [];
    let list = [];
    if (cat.collection) {
      list = await fetchCollection(cat.collection);
    } else {
      list = await fetchCollection(BASE_COLLECTION);
    }
    if (cat.tag) {
      const tags = String(cat.tag).split(',').map(norm).filter(Boolean);
      list = list.filter((p) => (p.tags || []).some((t) => tags.includes(norm(t))));
    }
    list = list.filter((p) => (p.variants || []).some((v) => v.available));
    if (norm(cat.slug) !== 'kits') list = list.filter((p) => !isKit(p));
    const l = currentList();
    if (state.mode === 'city' && l && l.cycleTag) {
      const ct = norm(l.cycleTag);
      const filtered = list.filter((p) => (p.tags || []).some((t) => norm(t) === ct));
      if (filtered.length) list = filtered;
    }
    return list;
  }

  // ---------- Filtros ----------
  const GENDER = { masculino: 'Masculino', feminino: 'Feminino', unissex: 'Unissex', menino: 'Masculino', menina: 'Feminino' };
  const AGE = { baby: 'Baby', bercario: 'Baby', infantil: 'Infantil', kids: 'Kids', juvenil: 'Juvenil', adulto: 'Adulto' };
  // Faixa etária derivada da categoria do produto (mesma separação, rótulo diferente)
  const AGE_RANGE = {
    Baby: '6 meses à 2 anos',
    Kids: '3 à 5 anos',
    Infantil: '6 à 11 anos',
    Juvenil: '12 à 16 anos',
    Adulto: '+ 16 anos'
  };
  const FILTER_KEYS = ['categoria', 'idade', 'genero', 'cor', 'marca'];
  // Filtros com ordem própria; os demais saem em ordem alfabética
  const FILTER_ORDER = {
    categoria: ['Baby', 'Kids', 'Infantil', 'Juvenil', 'Adulto'],
    idade: ['6 meses à 2 anos', '3 à 5 anos', '6 à 11 anos', '12 à 16 anos', '+ 16 anos'],
    genero: ['Feminino', 'Masculino', 'Unissex']
  };
  // Facetas vêm das tags msl:<faceta>:<valor> aplicadas no produto
  function mslTagValues(p, key) {
    const pre = 'msl:' + key + ':';
    return (p.tags || [])
      .map((t) => String(t).trim())
      .filter((t) => t.toLowerCase().indexOf(pre) === 0)
      .map((t) => t.slice(pre.length).trim())
      .filter(Boolean);
  }
  function sortFilterValues(key, values) {
    const order = FILTER_ORDER[key];
    if (!order) return values.sort((a, b) => a.localeCompare(b, 'pt-BR'));
    return values.sort((a, b) => {
      const ia = order.indexOf(a), ib = order.indexOf(b);
      if (ia < 0 && ib < 0) return a.localeCompare(b, 'pt-BR');
      if (ia < 0) return 1;
      if (ib < 0) return -1;
      return ia - ib;
    });
  }
  const CAT_FILTERS = {
    'caderno-universitario': {
      label: 'Matéria',
      options: [
        { name: '1 Matéria - 80 folhas', tag: 'lista:caderno-universitario-80' },
        { name: '10 Matérias - 160 folhas', tag: 'lista:caderno-universitario-160' }
      ]
    }
  };

  const FILTER_LABELS = { categoria: 'Categoria', idade: 'Idade', genero: 'Gênero', cor: 'Cor', marca: 'Marca' };
  // Cria o select que faltar e reordena a linha de filtros conforme FILTER_KEYS
  function ensureFilterSlots() {
    if (!el.filters) return;
    FILTER_KEYS.forEach((key) => {
      let select = el.filters.querySelector(`[data-msl-filter="${key}"]`);
      if (!select) {
        const wrap = document.createElement('label');
        wrap.className = 'msl-filter';
        wrap.setAttribute('data-filter', key);
        wrap.innerHTML = `<span class="msl-filter__label">${esc(FILTER_LABELS[key])}</span>`
          + `<select data-msl-filter="${key}"><option value="">${esc(FILTER_LABELS[key])}</option></select>`
          + '<span class="msl-filter__arrow" aria-hidden="true"></span>';
        el.filters.appendChild(wrap);
        select = wrap.querySelector('select');
      }
      const wrap = select.closest('.msl-filter');
      if (select.options[0]) select.options[0].textContent = FILTER_LABELS[key];
      const lbl = wrap.querySelector('.msl-filter__label');
      if (lbl) lbl.textContent = FILTER_LABELS[key];
      el.filters.appendChild(wrap);
    });
    const extra = el.filters.querySelector('[data-msl-extra]');
    if (extra) el.filters.appendChild(extra);
  }
  if (onPage) ensureFilterSlots();

  function productFacets(p) {
    const tags = (p.tags || []).map(norm);

    const cats = mslTagValues(p, 'categoria');
    const categoria = cats.length ? cats.join('|') : (tags.map((t) => AGE[t]).find(Boolean) || '');
    // Idade é a mesma separação da categoria, só com o rótulo por faixa etária
    const idade = categoria.split('|').map((c) => AGE_RANGE[c]).filter(Boolean).join('|');

    const gens = mslTagValues(p, 'genero');
    const genero = gens.length ? gens.join('|') : (tags.map((t) => GENDER[t]).find(Boolean) || '');

    const marca = p.vendor && norm(p.vendor) !== 'kit fechado' ? p.vendor : '';

    let cor = mslTagValues(p, 'cor').join('|');
    if (!cor) {
      const opt = (p.options || []).find((o) => /^cor$/i.test(o.name || o));
      if (opt && opt.values) cor = opt.values.join('|');
      else if (opt) { const idx = (p.options || []).indexOf(opt); cor = (p.variants || []).map((v) => v['option' + (idx + 1)]).filter(Boolean).join('|'); }
    }
    return { categoria, idade, genero, cor, marca };
  }

  function buildFilters(products) {
    if (!el.filters) return;
    const facets = products.map(productFacets);
    FILTER_KEYS.forEach((key) => {
      const select = el.filters.querySelector(`[data-msl-filter="${key}"]`);
      if (!select) { filterValues[key] = ''; return; }
      const wrap = select.closest('.msl-filter');
      const values = sortFilterValues(key, [...new Set(facets.flatMap((f) => (f[key] ? f[key].split('|') : [])))].filter(Boolean));
      const label = select.options[0].textContent;
      select.innerHTML = `<option value="">${esc(label)}</option>` + values.map((v) => `<option value="${esc(v)}">${esc(v)}</option>`).join('');
      if (values.includes(filterValues[key])) select.value = filterValues[key]; else filterValues[key] = '';
      select.classList.toggle('is-active', !!filterValues[key]);
      wrap.hidden = values.length < 2;
    });
    buildExtraFilter(products);
    const visible = [...el.filters.querySelectorAll('.msl-filter')].some((w) => !w.hidden);
    el.filters.classList.toggle('is-empty', !visible);
  }

  function buildExtraFilter(products) {
    if (!el.filters) return;
    const cat = currentCategory();
    const conf = cat ? CAT_FILTERS[cat.slug] : null;
    let wrap = el.filters.querySelector('[data-msl-extra]');
    if (!conf) { filterValues.extra = ''; if (wrap) wrap.hidden = true; return; }
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'msl-filter';
      wrap.setAttribute('data-msl-extra', '');
      wrap.innerHTML = '<select data-msl-filter="extra"></select><span class="msl-filter__arrow" aria-hidden="true"></span>';
      el.filters.appendChild(wrap);
    }
    const sel = wrap.querySelector('select');
    const avail = conf.options.filter((o) => products.some((p) => (p.tags || []).some((t) => norm(t) === norm(o.tag))));
    sel.innerHTML = `<option value="">${esc(conf.label)}</option>` + avail.map((o) => `<option value="${esc(o.tag)}">${esc(o.name)}</option>`).join('');
    if (avail.some((o) => o.tag === filterValues.extra)) sel.value = filterValues.extra; else filterValues.extra = '';
    sel.classList.toggle('is-active', !!filterValues.extra);
    wrap.hidden = avail.length < 2;
  }

  function applyFilters(products) {
    return products.filter((p) => {
      if (filterValues.extra && !(p.tags || []).some((t) => norm(t) === norm(filterValues.extra))) return false;
      const f = productFacets(p);
      return FILTER_KEYS.every((k) => !filterValues[k] || (f[k] || '').split('|').includes(filterValues[k]));
    });
  }

  if (el.filters) el.filters.addEventListener('change', (e) => {
    const key = e.target.dataset.mslFilter; if (!key) return;
    filterValues[key] = e.target.value; e.target.classList.toggle('is-active', !!e.target.value);
    renderGrid();
    track('msl_filtrar', {
      msl_filtro: key,
      msl_filtro_valor: e.target.value || null,
      msl_filtro_acao: e.target.value ? 'aplicar' : 'limpar',
      msl_resultados: applyFilters(currentProducts).length
    });
  });

  // ---------- Grade ----------
  function productImage(p, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    return (p.images && p.images[0] && p.images[0].src) || (p.featured_image) || '';
  }

  async function loadCategory() {
    if (!onPage) return;
    const cat = currentCategory();
    el.grid.innerHTML = `<li class="msl-grid__loading">Carregando produtos...</li>`;
    if (!cat) {
      currentProducts = (await fetchCollection(BASE_COLLECTION)).filter((p) => (p.variants || []).some((v) => v.available));
    } else {
      currentProducts = await productsForCategory(cat);
      if (state.mode === 'city' && !currentProducts.length) {
        toast(T.emptyCategory);
        state.skipped = state.skipped || [];
        if (!state.skipped.includes(cat.slug)) state.skipped.push(cat.slug);
        const steps = currentSteps();
        if (state.step < steps.length - 1) { state.step++; save(); return loadCategory(); }
      }
    }
    buildFilters(currentProducts);
    renderGrid();
    renderCatbar();
    renderStatus();
    track('msl_ver_categoria', { msl_produtos_disponiveis: currentProducts.length });
  }

  const ADDED_STATE_MS = 2000;
  let addedTimer = null;
  function isRecentlyAdded(it) { return !!it && (Date.now() - (it.added || 0) < ADDED_STATE_MS); }
  function addLabel(inList) {
    if (!inList) return esc(T.addToList);
    return 'NA LISTA ✓';
  }
  function stepperHTML(it) {
    return `<div class="msl-stepper" role="group" aria-label="Quantidade na lista">
      <button type="button" data-msl-grid-minus="${esc(it.key)}" aria-label="Diminuir quantidade">−</button>
      <span>${it.qty}</span>
      <button type="button" data-msl-grid-plus="${esc(it.key)}" aria-label="Aumentar quantidade">+</button>
    </div>`;
  }
  function scheduleAddedRefresh(items) {
    if (addedTimer) { clearTimeout(addedTimer); addedTimer = null; }
    const left = items.filter(isRecentlyAdded).map((i) => ADDED_STATE_MS - (Date.now() - i.added));
    if (!left.length) return;
    addedTimer = setTimeout(renderGrid, Math.max(250, Math.min.apply(null, left) + 60));
  }

  function cardHTML(p, variant, inList, selected, multi) {
    const price = parseFloat(variant.price);
    const compare = parseFloat(variant.compare_at_price || 0);
    const img = productImage(p, variant);
    const title = esc(p.title);
    const url = '/products/' + p.handle;
    const scheme = CARD_SCHEME ? ' color-' + CARD_SCHEME + ' gradient' : '';
    const media = img
      ? `<div class="card__media"><div class="media media--transparent media--hover-effect">
           <img src="${esc(img)}" alt="${title}" loading="lazy" width="533" height="533" class="motion-reduce"></div></div>`
      : '';
    const priceHTML = compare > price
      ? `<div class="price price--on-sale"><div class="price__container"><div class="price__sale">
           <span><s class="price-item price-item--regular">${money(compare)}</s></span>
           <span class="price-item price-item--sale price-item--last">${money(price)}</span></div></div></div>`
      : `<div class="price"><div class="price__container"><div class="price__regular">
           <span class="price-item price-item--regular">${money(price)}</span></div></div></div>`;
    return `
      <div class="card-wrapper product-card-wrapper underline-links-hover">
        ${inList ? `<span class="msl-card-qty">${inList.qty}x</span>` : ''}
        <div class="card card--${CARD_STYLE} card--media" style="--ratio-percent: 100.0%;">
          <div class="card__inner${scheme} ratio" style="--ratio-percent: 100.0%;">
            ${media}
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading"><a href="${esc(url)}" class="full-unstyled-link" data-msl-view="${p.id}">${title}</a></h3>
              </div>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
              <div class="card__heading-wrapper">
                <h3 class="card__heading h5"><a href="${esc(url)}" class="full-unstyled-link" data-msl-view="${p.id}">${title}</a></h3>
              </div>
              ${multi ? `
              <div class="msl-card-variants" data-msl-variants="${p.id}" role="group" aria-label="Escolha a opção">
                ${variantsOf(p).map((v) => `<button type="button" class="msl-card-variant${selected && String(selected.id) === String(v.id) ? ' is-on' : ''}" data-msl-variant="${v.id}" data-product="${p.id}"${v.available ? '' : ' disabled'}>${esc(v.title)}</button>`).join('')}
              </div>
              <p class="msl-card-variant-error" data-msl-variant-error="${p.id}" role="alert" hidden>${esc(T.variantRequired)}</p>` : ''}
              <div class="card-information">${priceHTML}</div>
              <div class="msl-add-wrap">
                ${inList && !isRecentlyAdded(inList)
                  ? stepperHTML(inList)
                  : `<button type="button" class="msl-add button button--primary${inList ? ' is-added' : ''}" data-msl-add="${p.id}" data-variant="${selected ? selected.id : ''}">${addLabel(inList)}</button>`}
              </div>
            </div>
          </div>
        </div>
      </div>`;
  }

  function renderGrid() {
    if (!el.grid) return;
    const cat = currentCategory();
    const list = applyFilters(currentProducts);
    if (!list.length) {
      el.grid.innerHTML = `<li class="msl-grid__empty">${esc(T.emptyCategory)}</li>`;
      return;
    }
    const shown = [];
    el.grid.innerHTML = list.map((p) => {
      const multi = isMultiVariant(p);
      const selected = selectedVariantOf(p);
      // Sem escolha ainda: mostra preço e imagem de uma variante de referência,
      // mas o produto não conta como estando na lista.
      const variant = selected || pickVariant(p, cat && cat.variant);
      const inList = selected ? state.items.find((i) => i.productId === p.id && i.variantId === selected.id) : null;
      if (inList) shown.push(inList);
      return `<li class="grid__item">${cardHTML(p, variant, inList, selected, multi)}</li>`;
    }).join('');
    scheduleAddedRefresh(shown);
  }

  // Erro inline quando o usuário tenta adicionar sem escolher a variante
  function showVariantError(pid) {
    if (!el.grid) return;
    const box = el.grid.querySelector(`[data-msl-variant-error="${pid}"]`);
    const chips = el.grid.querySelector(`[data-msl-variants="${pid}"]`);
    if (box) box.hidden = false;
    if (chips) {
      chips.classList.add('is-invalid');
      chips.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  if (el.grid) el.grid.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-msl-grid-minus]');
    const plus = e.target.closest('[data-msl-grid-plus]');
    if (minus) { gridQty(minus.dataset.mslGridMinus, -1); return; }
    if (plus) { gridQty(plus.dataset.mslGridPlus, 1); return; }
    const variantBtn = e.target.closest('[data-msl-variant]');
    if (variantBtn) {
      selectedVariants[variantBtn.dataset.product] = variantBtn.dataset.mslVariant;
      renderGrid();
      const pv = currentProducts.find((x) => String(x.id) === variantBtn.dataset.product);
      const vv = pv && selectedVariantOf(pv);
      track('msl_selecionar_variante', {
        msl_produto_id: variantBtn.dataset.product,
        msl_produto_nome: pv ? pv.title : null,
        msl_variante_id: variantBtn.dataset.mslVariant,
        msl_variante_nome: vv ? vv.title : null
      });
      return;
    }
    const add = e.target.closest('[data-msl-add]');
    const view = e.target.closest('[data-msl-view]');
    if (add) {
      if (!state.mode) { track('msl_iniciar', { msl_origem: 'card_produto', msl_pagina: location.pathname }); return openStart(); }
      const p = currentProducts.find((x) => String(x.id) === add.dataset.mslAdd);
      if (!p) return;
      // Produto com variantes exige escolha explícita antes de entrar na lista
      const v = selectedVariantOf(p);
      if (!v) {
        showVariantError(p.id);
        track('msl_erro_variante', { msl_produto_id: String(p.id), msl_produto_nome: p.title });
        return;
      }
      addItem(p, v, currentQtyDefault(), 'card');
    } else if (view) {
      e.preventDefault();
      const p = currentProducts.find((x) => String(x.id) === view.dataset.mslView);
      openProduct(p);
    }
  });

  // ---------- Lista ----------
  function addItem(p, v, qty, origin) {
    if (!p || !v) return;
    const wasOver = isOver();
    const cat = currentCategory();
    const key = `${p.id}:${v.id}`;
    const existing = state.items.find((i) => i.key === key);
    if (existing) { existing.qty += qty; existing.added = Date.now(); }
    else {
      state.items.push({
        key, productId: p.id, variantId: v.id,
        title: p.title + (v.title && v.title !== 'Default Title' ? ' - ' + v.title : ''),
        handle: p.handle, image: productImage(p, v), price: parseFloat(v.price), qty,
        cat: cat ? cat.slug : '', type: p.product_type || 'Material', soldOut: false, added: Date.now()
      });
    }
    save(); renderGrid(); renderList(); renderCatbar(); renderFabs();
    const it = state.items.find((i) => i.key === key);
    trackEcom('msl_adicionar_item', parseFloat(v.price) * qty, [Object.assign(itemPayload(it), { quantity: qty })], {
      msl_origem_item: origin || 'card',
      msl_produto_handle: p.handle,
      msl_variante_nome: v.title
    });
    warnIfOver(wasOver);
  }
  function removeItem(key) {
    const it = state.items.find((i) => i.key === key);
    state.items = state.items.filter((i) => i.key !== key);
    save(); renderAll();
    if (it) trackEcom('msl_remover_item', it.price * it.qty, [itemPayload(it)]);
  }
  function gridQty(key, delta) {
    const it = state.items.find((i) => i.key === key); if (!it) return;
    if (delta < 0 && it.qty <= 1) { removeItem(key); return; }
    const wasOver = isOver();
    it.qty = it.qty + delta;
    save(); renderAll();
    track('msl_alterar_quantidade', {
      msl_origem_item: 'card', msl_delta: delta,
      msl_produto_nome: it.title, msl_quantidade: it.qty
    });
    warnIfOver(wasOver);
  }
  function changeQty(key, delta) {
    const it = state.items.find((i) => i.key === key); if (!it) return;
    const wasOver = isOver();
    it.qty = Math.max(1, it.qty + delta); save(); renderAll();
    track('msl_alterar_quantidade', {
      msl_origem_item: 'painel', msl_delta: delta,
      msl_produto_nome: it.title, msl_quantidade: it.qty
    });
    warnIfOver(wasOver);
  }

  function renderAll() { renderGrid(); renderList(); renderCatbar(); renderFabs(); if (state.summary) renderSummary(); }

  function renderFabs() {
    if (!onPage) return;
    root.classList.toggle('is-active', !!state.mode);
    el.fabs.hidden = !state.mode;
    const n = state.items.reduce((a, i) => a + i.qty, 0);
    el.count.hidden = n === 0; el.count.textContent = n;
    // O checklist virou aba do painel da lista; o botão flutuante saiu de cena
    const checklistBtn = root.querySelector('[data-msl-open-checklist]');
    if (checklistBtn) checklistBtn.hidden = true;
  }

  function renderStatus() {
    if (!el.status) return;
    if (!state.mode) { el.status.hidden = true; return; }
    const l = currentList();
    el.status.hidden = false;
    el.status.innerHTML = state.mode === 'city'
      ? `${esc(l ? l.name : '')} · Saldo ${money(state.balance)}`
      : `Lista por conta própria · Saldo ${money(state.balance)}`;
  }

  // ---------- Barra de categorias ----------
  // Rótulos "Voltar" / "Avançar" ao lado das setas
  function labelArrows() {
    if (el.prev && !el.prev.querySelector('.msl-catbar__label')) {
      const s = document.createElement('span');
      s.className = 'msl-catbar__label';
      s.textContent = T.prevLabel;
      el.prev.appendChild(s);
    }
    if (el.next && !el.next.querySelector('.msl-catbar__label')) {
      const s = document.createElement('span');
      s.className = 'msl-catbar__label';
      s.textContent = T.nextLabel;
      el.next.insertBefore(s, el.next.firstChild);
    }
  }
  if (onPage) labelArrows();

  function renderCatbar() {
    if (!el.catbar) return;
    if (!state.mode) { el.catbar.hidden = true; return; }
    el.catbar.hidden = false;
    let chips = '';
    if (state.mode === 'city') {
      const steps = currentSteps();
      chips = steps.map((s, i) => {
        const done = stepDone(s.category.slug);
        // No resumo nenhuma categoria fica marcada como atual
        const cls = (!state.summary && i === state.step) ? 'is-current' : done ? 'is-done' : (stepEmpty(s.category.slug) ? 'is-empty' : '');
        return `<button type="button" class="msl-chip ${cls}" data-msl-step="${i}">${esc(s.category.name)}</button>`;
      }).join('');
      el.prev.disabled = state.step === 0 && !state.summary;
      el.next.disabled = state.summary;
    } else {
      const curSlug = (currentCategory() || {}).slug;
      chips = CFG.ownCategories.map((c) => `<button type="button" class="msl-chip is-free ${!state.summary && c.slug === curSlug ? 'is-current' : ''}" data-msl-cat="${esc(c.slug)}">${esc(c.name)}</button>`).join('');
      const idx = CFG.ownCategories.findIndex((c) => c.slug === curSlug);
      el.prev.disabled = idx <= 0 && !state.summary;
      el.next.disabled = state.summary;
    }
    chips += `<button type="button" class="msl-chip msl-chip--summary ${state.summary ? 'is-current' : ''}" data-msl-summary-chip>Resumo</button>`;
    el.chips.innerHTML = chips;
    const cur = el.chips.querySelector('.is-current');
    if (cur) cur.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }

  if (el.chips) el.chips.addEventListener('click', (e) => {
    const b = e.target.closest('button'); if (!b || b.disabled) return;
    if (b.dataset.mslSummaryChip != null) { track('msl_navegar', { msl_direcao: 'chip_resumo' }); showSummary(); return; }
    track('msl_navegar', { msl_direcao: 'chip', msl_destino: b.textContent.trim() });
    if (b.dataset.mslStep != null) { state.step = +b.dataset.mslStep; }
    else if (b.dataset.mslCat) { state.catSlug = b.dataset.mslCat; }
    state.summary = false; el.summary.hidden = true; el.grid.hidden = false; el.filters.hidden = false;
    root.classList.remove('is-summary');
    save(); loadCategory().then(scrollToTop);
  });
  if (el.prev) el.prev.addEventListener('click', () => {
    track('msl_navegar', { msl_direcao: 'voltar' });
    if (state.summary) {
      if (state.mode === 'city') state.step = Math.max(0, currentSteps().length - 1);
      else { const last = CFG.ownCategories[CFG.ownCategories.length - 1]; if (last) state.catSlug = last.slug; }
    } else if (state.mode === 'city') { if (state.step > 0) state.step--; }
    else { const i = CFG.ownCategories.findIndex((c) => c.slug === currentCategory().slug); if (i > 0) state.catSlug = CFG.ownCategories[i - 1].slug; }
    state.summary = false; el.summary.hidden = true; el.grid.hidden = false; el.filters.hidden = false;
    root.classList.remove('is-summary');
    save(); loadCategory().then(scrollToTop);
  });
  if (el.next) el.next.addEventListener('click', () => {
    track('msl_navegar', { msl_direcao: 'avancar' });
    if (state.mode === 'city') {
      const steps = currentSteps();
      if (state.step < steps.length - 1) {
        state.step++; save();
        loadCategory().then(scrollToTop);
      }
      else { showSummary(); }
    } else {
      const i = CFG.ownCategories.findIndex((c) => c.slug === currentCategory().slug);
      if (i < CFG.ownCategories.length - 1) { state.catSlug = CFG.ownCategories[i + 1].slug; save(); loadCategory().then(scrollToTop); }
      else { showSummary(); }
    }
  });

  // ---------- Acessibilidade ----------
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const isMobile = () => window.matchMedia('(max-width:989px)').matches;
  let scrollTop = 0, locks = 0, activeModal = null, lastFocused = null;

  function lockScroll() {
    if (locks++ > 0) return;
    scrollTop = window.scrollY || document.documentElement.scrollTop;
    const b = document.body.style;
    b.position = 'fixed'; b.top = `-${scrollTop}px`; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unlockScroll() {
    locks = Math.max(0, locks - 1);
    if (locks > 0) return;
    const b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    window.scrollTo(0, scrollTop);
  }
  function releaseScroll() {
    if (locks > 0) { locks = 1; unlockScroll(); }
    activeModal = null; lastFocused = null;
  }
  function setModal(node, label) {
    if (node) {
      if (!activeModal) lastFocused = document.activeElement;
      activeModal = node;
      node.setAttribute('role', 'dialog');
      node.setAttribute('aria-modal', 'true');
      node.setAttribute('tabindex', '-1');
      if (label) node.setAttribute('aria-label', label);
      lockScroll();
      const first = node.querySelector(FOCUSABLE);
      (first || node).focus({ preventScroll: true });
    } else {
      activeModal = null;
      unlockScroll();
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
      lastFocused = null;
    }
  }
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !activeModal) return;
    const f = [...activeModal.querySelectorAll(FOCUSABLE)].filter((n) => n.offsetParent !== null);
    if (!f.length) { e.preventDefault(); activeModal.focus({ preventScroll: true }); return; }
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // ---------- Overlay / cards ----------
  let cardLocked = false;
  function openCard(html, opts = {}) {
    cardLocked = !!opts.locked;
    el.card.className = 'msl-card' + (opts.cls ? ' ' + opts.cls : '');
    el.card.innerHTML = html;
    el.overlay.hidden = false;
    const title = el.card.querySelector('.msl-card__title');
    setModal(el.card, title ? title.textContent.trim() : 'Monte sua lista');
  }
  function closeCard() {
    cardLocked = false; el.overlay.hidden = true; el.card.innerHTML = '';
    if (el.drawer && !el.drawer.hidden && isMobile()) { activeModal = null; unlockScroll(); setModal(el.drawer, 'Sua lista de material escolar'); }
    else setModal(null);
  }
  el.overlay.addEventListener('click', (e) => {
    if (e.target === el.overlay) { if (!cardLocked) closeCard(); return; }
    const act = e.target.closest('[data-msl-action]'); if (!act) return;
    handleAction(act.dataset.mslAction, act);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { if (!el.overlay.hidden) { if (!cardLocked) closeCard(); } else if (el.drawer && !el.drawer.hidden) closeList(); } });

  const closeBtn = (cls = '') => `<button type="button" class="msl-close ${cls}" data-msl-action="close" aria-label="Fechar"></button>`;

  function openStart() {
    // Também dispara quando a página abre sem fluxo escolhido, cobrindo a impressão do card
    track('msl_ver_card_inicio');
    openCard(`
      <div class="msl-card__head"><h2 class="msl-card__title">${esc(T.startTitle)}</h2>${closeBtn()}</div>
      <p class="msl-card__text">${esc(T.startText)}</p>
      <div class="msl-btn-stack">
        <button type="button" class="msl-btn" data-msl-action="own">${esc(T.startOwn)}</button>
        <button type="button" class="msl-btn" data-msl-action="city">${esc(T.startCity)}</button>
      </div>`);
  }

  function openBalanceEdit() {
    const atual = state.balance ? String(state.balance.toFixed(2)).replace('.', ',') : '';
    openCard(`
      <div class="msl-card__head"><h2 class="msl-card__title msl-card__title--left">VOCÊ PODE AJUSTAR O SEU SALDO</h2>${closeBtn()}</div>
      <p class="msl-card__text msl-card__text--left">Só digitar o valor real abaixo.</p>
      <div class="msl-input-money"><input class="msl-input" type="text" inputmode="decimal" placeholder="Insira aqui o valor" data-msl-balance value="${atual}" autocomplete="off"></div>
      <p class="msl-error" data-msl-error hidden>Informe um valor válido.</p>
      <button type="button" class="msl-btn" data-msl-action="update-balance">${esc(T.balanceButton)}</button>`);
    const input = el.card.querySelector('[data-msl-balance]');
    input.addEventListener('keydown', (e) => { if (e.key === 'Enter') handleAction('update-balance'); });
  }

  function openBalance() {
    openCard(`
      <div class="msl-card__head"><h2 class="msl-card__title msl-card__title--left">${esc(T.balanceTitle)}</h2></div>
      <p class="msl-card__text msl-card__text--left">${esc(T.balanceQuestion)}</p>
      <p class="msl-card__help">${esc(T.balanceHelp)}</p>
      <div class="msl-input-money"><input class="msl-input" type="text" inputmode="decimal" placeholder="Insira aqui o valor" data-msl-balance value="" autocomplete="off"></div>
      <p class="msl-error" data-msl-error hidden>Informe um valor válido.</p>
      <button type="button" class="msl-btn" data-msl-action="save-balance">${esc(T.balanceButton)}</button>
      <button type="button" class="msl-link" data-msl-action="start">${esc(T.back)}</button>`, { locked: true });
    const input = el.card.querySelector('[data-msl-balance]');
    input.addEventListener('keydown', (e) => { if (e.key === 'Enter') handleAction('save-balance'); });
  }

  function openCity() {
    openCard(`
      <div class="msl-card__head"><h2 class="msl-card__title">${esc(T.cityTitle)}</h2></div>
      <p class="msl-card__text">${esc(T.cityText)}</p>
      <div class="msl-btn-stack">
        ${CFG.lists.length ? CFG.lists.map((l) => `<button type="button" class="msl-btn" data-msl-action="pick-list" data-list="${esc(l.handle)}">${esc(l.button)}</button>`).join('') : `<p class="msl-card__help">Não foi possível carregar as listas agora. Tente novamente em instantes ou monte sua lista por conta própria.</p>`}
      </div>
      <button type="button" class="msl-link" data-msl-action="start">${esc(T.back)}</button>`, { locked: true });
  }

  function openConfirm() {
    const l = currentList(); if (!l) return;
    openCard(`
      <div class="msl-card__head"><h2 class="msl-card__title">${esc(l.name)}</h2></div>
      <p class="msl-card__text msl-card__text--left"><strong>${esc(T.listItemsLabel)}</strong></p>
      <ul class="msl-check msl-check--bullets">${l.items.map((i) => `<li>${esc(i.category.name)}</li>`).join('')}</ul>
      <button type="button" class="msl-btn" data-msl-action="confirm-list">${esc(T.confirmList)}</button>
      <button type="button" class="msl-link" data-msl-action="city">${esc(T.back)}</button>`, { locked: true });
  }

  function openProduct(p) {
    if (!p) return;
    const cat = currentCategory();
    const variant = pickVariant(p, cat && cat.variant);
    trackEcom('msl_ver_produto', parseFloat(variant.price), [{
      item_id: String(variant.id), item_name: p.title,
      item_category: cat ? cat.slug : undefined, price: round2(variant.price), quantity: 1
    }], { msl_produto_id: String(p.id), msl_produto_handle: p.handle });
    const imgs = (p.images || []).map((i) => i.src); if (!imgs.length) imgs.push(productImage(p, variant));
    let idx = 0;
    const hasVariants = (p.variants || []).length > 1;
    openCard(`
      <div class="msl-carousel">
        <div class="msl-carousel__track" data-track>${imgs.map((s) => `<img src="${esc(s)}" alt="${esc(p.title)}">`).join('')}</div>
        ${imgs.length > 1 ? `<button type="button" class="msl-carousel__arrow msl-carousel__arrow--prev" data-car="-1" aria-label="Imagem anterior"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg></button>
        <button type="button" class="msl-carousel__arrow msl-carousel__arrow--next" data-car="1" aria-label="Próxima imagem"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg></button>
        <div class="msl-carousel__dots" data-dots>${imgs.map((_, i) => `<i class="${i === 0 ? 'is-on' : ''}"></i>`).join('')}</div>` : ''}
      </div>
      <div class="msl-product-modal__row"><p class="msl-product-modal__title">${esc(p.title)}</p><p class="msl-product-modal__price" data-price>${money(variant.price)}</p></div>
      ${hasVariants
        ? `<p class="msl-product-modal__hint">${esc(T.variantOnCard)}</p>`
        : `<div class="msl-product-modal__actions"><button type="button" class="msl-btn" data-msl-action="add-modal">${esc(T.addToList)}</button></div>`}
      ${closeBtn('msl-close--corner')}`, { cls: 'msl-card--product' });

    // Renomeado para não sombrear a função track() do datalayer
    const track2 = el.card.querySelector('[data-track]'), dots = el.card.querySelectorAll('[data-dots] i');
    const goTo = (n) => {
      idx = (n + imgs.length) % imgs.length;
      track2.style.transform = `translateX(-${idx * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('is-on', i === idx));
    };
    el.card.querySelectorAll('[data-car]').forEach((b) => b.addEventListener('click', () => goTo(idx + (+b.dataset.car))));
    // Produto com variantes: o modal é só visualização, a escolha acontece no card
    const addBtn = el.card.querySelector('[data-msl-action="add-modal"]');
    if (addBtn) addBtn.addEventListener('click', () => {
      closeCard(); addItem(p, variant, currentQtyDefault(), 'modal');
    });
  }

  function openReceive() {
    openCard(`
      <div class="msl-card__head"><h2 class="msl-card__title msl-card__title--left">${esc(T.receiveTitle)}</h2>${closeBtn()}</div>
      <p class="msl-card__text msl-card__text--left">${esc(T.receiveText)}</p>
      <input class="msl-input" type="text" placeholder="Nome" data-msl-name autocomplete="name">
      <input class="msl-input" type="tel" inputmode="tel" placeholder="Whatsapp" data-msl-phone autocomplete="tel">
      <input class="msl-input" type="email" placeholder="E-mail" data-msl-email autocomplete="email">
      <p class="msl-error" data-msl-error hidden></p>
      <button type="button" class="msl-btn" data-msl-action="send-list">${esc(T.receiveButton)}</button>`);
  }

  function listAsText() {
    const l = currentList();
    const head = l ? `${l.name} (saldo ${money(state.balance)})` : `Lista por conta própria (saldo ${money(state.balance)})`;
    const lines = state.items.map((i) => `- ${i.qty}x ${i.title} - ${money(i.price * i.qty)}`);
    return `${head}\n\n${lines.join('\n')}\n\nTotal: ${money(total())}\n${location.origin}${PAGE_URL}`;
  }

  async function sendList() {
    const name = (el.card.querySelector('[data-msl-name]').value || '').trim();
    const phone = (el.card.querySelector('[data-msl-phone]').value || '').replace(/\D/g, '');
    const email = (el.card.querySelector('[data-msl-email]').value || '').trim();
    const err = el.card.querySelector('[data-msl-error]');
    if (!name) { err.textContent = 'Informe seu nome.'; err.hidden = false; return; }
    if (phone.length < 10) { err.textContent = 'Informe um Whatsapp válido com DDD.'; err.hidden = false; return; }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { err.textContent = 'Informe um e-mail válido.'; err.hidden = false; return; }
    err.hidden = true;
    localStorage.setItem('msl_saved_list', JSON.stringify({ at: Date.now(), name, email, phone, items: state.items, balance: state.balance, list: state.listHandle }));
    await sendToKlaviyo(email, phone, name);
    trackEcom('msl_enviar_lista', total(), state.items.map(itemPayload));
    openCard(`<div class="msl-card__head"><h2 class="msl-card__title">${esc(T.receiveDone)}</h2>${closeBtn()}</div>`);
  }

  async function sendToKlaviyo(email, phone, name) {
    const KEY = app.dataset.klaviyoKey || '';
    const l = currentList();
    const payload = {
      data: {
        type: 'event',
        attributes: {
          properties: {
            lista: l ? l.name : 'Lista por conta própria',
            saldo: state.balance,
            total: total(),
            quantidade_itens: state.items.reduce((a, i) => a + i.qty, 0),
            url_lista: `${location.origin}${PAGE_URL}`,
            itens: state.items.map((i) => ({
              titulo: i.title, quantidade: i.qty, preco: i.price,
              subtotal: i.price * i.qty, imagem: i.image,
              url: i.handle ? `${location.origin}/products/${i.handle}` : ''
            }))
          },
          metric: { data: { type: 'metric', attributes: { name: 'Lista de Material Criada' } } },
          profile: { data: { type: 'profile', attributes: { email, first_name: name || undefined, phone_number: phone ? `+55${phone}` : undefined } } }
        }
      }
    };
    if (!KEY) { console.warn('[MSL] Klaviyo public key ausente; evento não enviado.'); return; }
    try {
      await fetch(`https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(KEY)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      });
    } catch (e) { console.warn('[MSL] Falha ao enviar evento ao Klaviyo', e); }
  }

  function handleAction(action, btn) {
    switch (action) {
      case 'close': {
        const wasStart = !!el.card.querySelector('[data-msl-action="own"]');
        closeCard();
        if (wasStart && onPage && !state.mode) loadCategory();
        break;
      }
      case 'start': openStart(); break;
      case 'own': track('msl_escolher_fluxo', { msl_fluxo_escolhido: 'conta_propria' }); openBalance(); break;
      case 'city': track('msl_escolher_fluxo', { msl_fluxo_escolhido: 'prefeitura' }); openCity(); break;
      case 'save-balance': {
        const input = el.card.querySelector('[data-msl-balance]');
        const v = parseFloat(String(input.value).replace(/\s/g, '').replace(/\./g, '').replace(',', '.'));
        if (!(v > 0)) { el.card.querySelector('[data-msl-error]').hidden = false; input.focus(); track('msl_erro_saldo'); return; }
        // Troca de fluxo: descarta o saldo do fluxo anterior antes de aplicar o novo
        resetBalance();
        state.mode = 'own'; state.listHandle = null; state.step = 0; state.summary = false; state.skipped = []; state.pendingConfirm = false;
        state.catSlug = CFG.ownCategories[0] ? CFG.ownCategories[0].slug : null;
        state.items = state.items.filter((i) => i.cat && CFG.ownCategories.some((c) => c.slug === i.cat));
        setBalance(v);
        track('msl_definir_saldo', { msl_saldo_informado: round2(v) });
        closeCard(); goToFlow();
        break;
      }
      case 'pick-list': {
        const l = CFG.lists.find((x) => x.handle === btn.dataset.list); if (!l) return;
        closeCard();
        // Troca de fluxo: descarta o saldo do fluxo anterior antes de aplicar o da lista
        resetBalance();
        state.mode = 'city'; state.listHandle = l.handle; state.step = 0; state.summary = false; state.items = []; state.skipped = [];
        state.pendingConfirm = true;
        setBalance(Number(l.balance) || 0);
        track('msl_selecionar_lista', { msl_lista_botao: l.button, msl_lista_saldo: round2(l.balance) });
        showLoading(fmt(T.loadingList, { nome: l.name }));
        setTimeout(() => goToFlow(true), 700);
        break;
      }
      case 'update-balance': {
        const input = el.card.querySelector('[data-msl-balance]');
        const v = parseFloat(String(input.value).replace(/\s/g, '').replace(/\./g, '').replace(',', '.'));
        if (!(v > 0)) { el.card.querySelector('[data-msl-error]').hidden = false; input.focus(); track('msl_erro_saldo'); return; }
        setBalance(v);
        track('msl_ajustar_saldo', { msl_saldo_informado: round2(v) });
        closeCard();
        break;
      }
      case 'confirm-list': track('msl_confirmar_lista'); closeCard(); break;
      case 'save': openReceive(); break;
      case 'send-list': sendList(); break;
      case 'add-cart': addToCart(); break;
      case 'skip-out': track('msl_esgotado_seguir'); closeCard(); dropSoldOut(); addToCart(true); break;
      case 'replace-out': {
        track('msl_esgotado_trocar');
        const first = state.items.find((i) => i.soldOut);
        const slug = first ? first.cat : null;
        closeCard(); dropSoldOut();
        if (onPage && slug) {
          state.summary = false; root.classList.remove('is-summary');
          el.summary.hidden = true; el.grid.hidden = false; el.filters.hidden = false;
          if (state.mode === 'city') {
            const idx = currentSteps().findIndex((x) => x.category.slug === slug);
            if (idx >= 0) state.step = idx;
          } else { state.catSlug = slug; }
          save(); loadCategory();
        }
        break;
      }
    }
  }

  function goToFlow(keepLoading) {
    save();
    if (!onPage) { window.location.href = PAGE_URL; return; }
    startMode().then(() => {
      if (keepLoading) hideLoading();
      if (state.pendingConfirm) { state.pendingConfirm = false; save(); openConfirm(); }
    });
  }

  async function startMode() {
    save();
    if (!onPage) return;
    root.classList.remove('is-summary');
    el.summary.hidden = true; el.grid.hidden = false; el.filters.hidden = false;
    renderFabs(); renderStatus();
    // O painel da lista fica sempre visível no desktop: precisa ser redesenhado
    // ao entrar num fluxo, senão mantém o saldo e os itens do fluxo anterior
    renderList();
    await loadCategory();
    if (el.grid) el.grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function scrollToTop() {
    if (!onPage) return;
    const main = root.querySelector('.msl-main') || el.grid;
    if (!main) return;
    const off = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--msl-header'), 10) || 0;
    const y = window.scrollY + main.getBoundingClientRect().top - off - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  function buildStickyBar() {
    if (!onPage || !el.catbar || !el.filters) return;
    if (el.filters.closest('.msl-sticky')) return;
    const wrap = document.createElement('div');
    wrap.className = 'msl-sticky';
    el.filters.parentNode.insertBefore(wrap, el.filters);
    wrap.appendChild(el.catbar);
    wrap.appendChild(el.filters);
  }
  if (onPage) buildStickyBar();

  let headerPx = -1, headerTick = false;
  function syncHeaderOffset() {
    const h = document.querySelector('.section-header') || document.querySelector('#shopify-section-header') || document.querySelector('header.header');
    if (!h) return;
    const r = h.getBoundingClientRect();
    const px = Math.max(0, Math.round(Math.min(r.bottom, r.height)));
    if (px === headerPx) return;
    headerPx = px;
    document.documentElement.style.setProperty('--msl-header', px + 'px');
  }
  function queueHeaderOffset() {
    if (headerTick) return;
    headerTick = true;
    requestAnimationFrame(() => { headerTick = false; syncHeaderOffset(); });
  }
  if (onPage) {
    syncHeaderOffset();
    window.addEventListener('resize', queueHeaderOffset);
    window.addEventListener('scroll', queueHeaderOffset, { passive: true });
    window.addEventListener('load', syncHeaderOffset);
    setTimeout(syncHeaderOffset, 600);
  }

  function showLoading(text) { if (el.loadingText) el.loadingText.textContent = text; if (el.loading) el.loading.hidden = false; }
  function hideLoading() { if (el.loading) el.loading.hidden = true; }

  function openList() {
    if (!el.drawer) return;
    renderList(); el.drawer.hidden = false;
    track('msl_abrir_painel');
    if (isMobile()) setModal(el.drawer, 'Sua lista de material escolar');
  }
  function closeList() {
    if (!el.drawer || el.drawer.hidden) return;
    el.drawer.hidden = true;
    track('msl_fechar_painel');
    if (activeModal === el.drawer) setModal(null);
  }

  if (onPage) {
    const bind = (sel, fn) => { const n = root.querySelector(sel); if (n) n.addEventListener('click', fn); };
    bind('[data-msl-close-drawer]', closeList);
    bind('[data-msl-open-list]', openList);
    root.querySelectorAll('[data-msl-save]').forEach((b) => { b.hidden = true; });
    bind('[data-msl-add-cart]', () => addToCart());
    buildDrawerTabs();
    buildClearButton();
    if (el.sort && el.sort.options[0]) el.sort.options[0].textContent = 'Ordenar por';
    if (el.sort) el.sort.addEventListener('change', () => { sortValue = el.sort.value || 'added'; renderList(); });
  }

  function sortedItems() {
    const arr = [...state.items];
    if (sortValue === 'price_asc') arr.sort((a, b) => a.price - b.price);
    else if (sortValue === 'price_desc') arr.sort((a, b) => b.price - a.price);
    else if (sortValue === 'name') arr.sort((a, b) => a.title.localeCompare(b.title));
    return arr;
  }

  function itemsHTML(items) {
    return items.map((i) => `
      <div class="msl-item${i.soldOut ? ' is-out' : ''}" data-key="${esc(i.key)}">
        <button type="button" class="msl-item__remove" data-msl-remove aria-label="Remover ${esc(i.title)}"></button>
        <img class="msl-item__img" src="${esc(i.image)}" alt="" width="56" height="56">
        <div><p class="msl-item__title">${esc(i.title)}</p><p class="msl-item__price">${money(i.price)}${i.soldOut ? ` <em class="msl-tag-out">${esc(T.outOfStock)}</em>` : ''}</p></div>
        <div class="msl-item__qty">Qtd<div class="msl-qty"><button type="button" data-msl-minus aria-label="Diminuir">−</button><span>${i.qty}</span><button type="button" data-msl-plus aria-label="Aumentar">+</button></div></div>
      </div>`).join('');
  }

  function isOver() { return state.balance != null && state.balance > 0 && total() > state.balance; }
  function warnIfOver(wasOver) {
    if (!wasOver && isOver()) {
      toast(`Você ultrapassou o saldo em ${money(total() - state.balance)}`);
      track('msl_estourar_saldo', { msl_excedente: round2(total() - state.balance) });
    }
  }

  function totalsHTML() {
    const t = total(), rem = (state.balance || 0) - t, over = state.balance != null && rem < 0;
    return `${over ? `<p class="msl-over">Você ultrapassou o saldo em ${money(-rem)}</p>` : ''}
    <div class="msl-totals ${over ? 'is-over' : ''}">
      <div class="msl-totals__meta"><span data-msl-balance-edit title="Ajustar saldo">${esc(T.balanceLabel)} <strong>${money(state.balance)}</strong></span><br>${esc(T.remainingLabel)} <strong class="rem">${money(rem)}</strong></div>
      <div class="msl-totals__label">${esc(T.totalLabel)}</div>
      <div class="msl-totals__value">${money(t)}</div>
    </div>`;
  }

  function buildClearButton() {
    const sortRow = root && root.querySelector('.msl-drawer__sort');
    if (!sortRow || sortRow.querySelector('[data-msl-clear]')) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'msl-clear';
    btn.setAttribute('data-msl-clear', '');
    btn.hidden = true;
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg> Limpar lista';
    btn.addEventListener('click', clearList);
    sortRow.insertBefore(btn, sortRow.firstChild);
    renderList();
  }

  function clearList() {
    if (!state.items.length) return;
    if (!window.confirm('Tem certeza que deseja remover todos os produtos da sua lista?')) {
      track('msl_limpar_lista_cancelado');
      return;
    }
    const removidos = state.items.reduce((a, i) => a + i.qty, 0);
    const valor = total();
    state.items = [];
    save(); renderAll();
    track('msl_limpar_lista', { msl_itens_removidos: removidos, msl_valor_removido: round2(valor) });
  }

  // ---------- Abas do painel: Minha lista / Lista da prefeitura ----------
  // Substituem o card de checklist que abria sozinho a cada avanço.
  function buildDrawerTabs() {
    if (!el.drawer || el.drawer.querySelector('[data-msl-tabs]')) return;
    const head = el.drawer.querySelector('.msl-drawer__head');
    const body = el.drawer.querySelector('.msl-drawer__body');
    if (!head || !body) return;

    const tabs = document.createElement('div');
    tabs.className = 'msl-drawer__tabs';
    tabs.setAttribute('data-msl-tabs', '');
    tabs.setAttribute('role', 'tablist');
    tabs.hidden = true;
    tabs.innerHTML =
      '<button type="button" class="msl-tab is-on" data-msl-tab="list" role="tab" aria-selected="true">Minha lista</button>'
      + '<button type="button" class="msl-tab" data-msl-tab="check" role="tab" aria-selected="false">Lista da prefeitura'
      + ' <span class="msl-tab__count" data-msl-tab-count></span></button>';
    head.insertBefore(tabs, head.firstChild);

    // O conteúdo que já existia vira a aba "Minha lista"
    const listPane = document.createElement('div');
    listPane.setAttribute('data-msl-listpane', '');
    while (body.firstChild) listPane.appendChild(body.firstChild);
    body.appendChild(listPane);

    const checkPane = document.createElement('div');
    checkPane.className = 'msl-checkpane';
    checkPane.setAttribute('data-msl-checkpane', '');
    checkPane.hidden = true;
    body.appendChild(checkPane);

    tabs.addEventListener('click', (e) => {
      const b = e.target.closest('[data-msl-tab]');
      if (!b || b.dataset.mslTab === drawerTab) return;
      setDrawerTab(b.dataset.mslTab);
      const p = checkProgress();
      track('msl_trocar_aba', {
        msl_aba: drawerTab === 'check' ? 'lista_prefeitura' : 'minha_lista',
        msl_progresso_concluido: p.done,
        msl_progresso_total: p.total
      });
    });
  }

  function setDrawerTab(tab) {
    if (!el.drawer) return;
    drawerTab = (tab === 'check' && state.mode === 'city') ? 'check' : 'list';
    el.drawer.querySelectorAll('[data-msl-tab]').forEach((b) => {
      const on = b.dataset.mslTab === drawerTab;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    const listPane = el.drawer.querySelector('[data-msl-listpane]');
    const checkPane = el.drawer.querySelector('[data-msl-checkpane]');
    if (listPane) listPane.hidden = drawerTab !== 'list';
    if (checkPane) checkPane.hidden = drawerTab !== 'check';
    if (drawerTab === 'check') renderCheckPane();
  }

  // O contador ignora categorias sem estoque: elas nunca poderiam ser concluídas
  function checkProgress() {
    const steps = currentSteps();
    return {
      done: steps.filter((s) => stepDone(s.category.slug)).length,
      total: steps.filter((s) => !stepEmpty(s.category.slug)).length
    };
  }

  function renderCheckPane() {
    const pane = el.drawer && el.drawer.querySelector('[data-msl-checkpane]');
    if (!pane) return;
    const l = currentList();
    if (!l) { pane.innerHTML = ''; return; }
    pane.innerHTML = `<ul class="msl-check">${l.items.map((i) => {
      const st = stepState(i.category.slug);
      const badge = st === 'done' ? `<em class="msl-linked">${esc(T.linked)}</em>`
        : st === 'empty' ? `<em class="msl-tag-out">${esc(T.outOfStock)}</em>`
        : `<em class="msl-tag-todo">${esc(T.notAdded)}</em>`;
      return `<li class="is-${st}"><span>${esc(i.category.name)}</span>${badge}</li>`;
    }).join('')}</ul>`;
  }

  function renderDrawerTabs() {
    if (!el.drawer) return;
    const tabs = el.drawer.querySelector('[data-msl-tabs]');
    if (!tabs) return;
    const city = state.mode === 'city';
    tabs.hidden = !city;
    // Fora do fluxo da prefeitura não existe lista de referência
    if (!city) { if (drawerTab !== 'list') setDrawerTab('list'); return; }
    const count = tabs.querySelector('[data-msl-tab-count]');
    if (count) { const p = checkProgress(); count.textContent = `${p.done}/${p.total}`; }
    if (drawerTab === 'check') renderCheckPane();
  }

  function renderList() {
    if (!el.items) return;
    const clearBtn = root && root.querySelector('[data-msl-clear]');
    if (clearBtn) clearBtn.hidden = !state.items.length;
    el.items.innerHTML = state.items.length ? itemsHTML(sortedItems()) : `<div class="msl-items__empty">Sua lista está vazia.</div>`;
    if (el.totals) el.totals.innerHTML = totalsHTML();
    renderDrawerTabs();
  }

  function bindItemEvents(container) {
    container.addEventListener('click', (e) => {
      const row = e.target.closest('.msl-item'); if (!row) return;
      const key = row.dataset.key;
      if (e.target.closest('[data-msl-remove]')) removeItem(key);
      else if (e.target.closest('[data-msl-minus]')) changeQty(key, -1);
      else if (e.target.closest('[data-msl-plus]')) changeQty(key, 1);
    });
  }
  if (el.items) bindItemEvents(el.items);
  if (el.summary) bindItemEvents(el.summary);

  if (onPage) {
    const openEdit = (e) => { if (state.mode && e.target.closest('[data-msl-balance-edit]')) { e.preventDefault(); openBalanceEdit(); } };
    root.addEventListener('dblclick', openEdit);
    root.addEventListener('click', (e) => { if (isMobile()) openEdit(e); });
  }

  // ---------- Resumo ----------
  function showSummary() {
    if (!onPage) return;
    state.summary = true; save();
    el.grid.hidden = true; el.filters.hidden = true;
    el.summary.hidden = false; root.classList.add('is-summary');
    renderSummary(); renderCatbar();
    const p = checkProgress();
    trackEcom('msl_ver_resumo', total(), state.items.map(itemPayload), {
      msl_progresso_concluido: p.done,
      msl_progresso_total: p.total,
      msl_saldo_restante: state.balance != null ? round2(state.balance - total()) : null
    });
    scrollToTop();
  }
  function renderSummary() {
    if (!el.summary) return;
    const l = currentList();
    const t = total(), rem = (state.balance || 0) - t, over = state.balance != null && rem < 0;
    el.summary.innerHTML = `
      <div class="msl-summary__main">
        <h2 class="msl-summary__title"><span class="msl-only-mobile">${esc(T.summaryTitle)}</span><span class="msl-only-desktop">${esc(T.summaryTitleDesktop)}</span></h2>
        <p class="msl-summary__lead msl-only-desktop">${esc(fmt(T.summaryLead, { lista: l ? l.name : 'sua lista' }))}</p>
        ${l ? `<div class="msl-summary__list"><h3>${esc(l.name)}</h3><p><span class="msl-only-mobile">${esc(T.listItemsLabel)}</span><span class="msl-only-desktop">${esc(T.recommended)}</span></p>
          <ul class="msl-check">${l.items.map((i) => { const st = stepState(i.category.slug); const badge = st === 'done' ? `<em class="msl-linked">${esc(T.linked)}</em>` : st === 'empty' ? `<em class="msl-tag-out">${esc(T.outOfStock)}</em>` : `<em class="msl-tag-todo">${esc(T.notAdded)}</em>`; return `<li class="is-${st}"><span>${esc(i.category.name)}</span>${badge}</li>`; }).join('')}</ul></div>` : ''}
        <p class="msl-summary__sub">${esc(T.summaryItems)}</p>
        <div class="msl-summary__items"><div class="msl-items">${itemsHTML(state.items)}</div></div>
      </div>
      <aside class="msl-summary__aside">
        <h3 class="msl-only-desktop">${esc(T.orderSummary)}</h3>
        <div class="msl-order msl-only-desktop">
          <div class="msl-order__row"><span>${esc(T.subtotalLabel)}</span><strong>${money(t)}</strong></div>
          <div class="msl-order__row msl-order__row--box" data-msl-balance-edit title="Ajustar saldo"><span>${esc(T.balanceBox)}</span><strong>${money(state.balance)}</strong></div>
          <div class="msl-order__row ${over ? 'is-over' : ''}"><span>${esc(T.remainingBox)}</span><strong>${money(rem)}</strong></div>
          <div class="msl-order__total"><span>${esc(T.summaryCost)}</span><strong>${money(t)}</strong></div>
        </div>
        <p class="msl-summary__sub msl-only-mobile">${esc(T.summaryCost)}</p>
        <div class="msl-only-mobile">${totalsHTML()}</div>
        <div class="msl-summary__totals">
          <button type="button" class="msl-btn" data-msl-summary-cart>${esc(T.addToCart)}</button>
          <button type="button" class="msl-link" data-msl-summary-back>${esc(T.back)}</button>
        </div>
      </aside>`;
    $('[data-msl-summary-cart]', el.summary).addEventListener('click', () => addToCart());
    $('[data-msl-summary-back]', el.summary).addEventListener('click', () => { track('msl_navegar', { msl_direcao: 'resumo_voltar' }); state.summary = false; save(); el.summary.hidden = true; el.grid.hidden = false; el.filters.hidden = false; root.classList.remove('is-summary'); loadCategory(); });
  }

  // ---------- Carrinho ----------
  async function addToCart(skipCheck) {
    if (!state.items.length) { toast('Sua lista está vazia.'); track('msl_sacola_lista_vazia'); return; }
    const btns = document.querySelectorAll('[data-msl-add-cart],[data-msl-summary-cart]');
    btns.forEach((b) => { b.disabled = true; });
    trackEcom('msl_adicionar_sacola', total(), state.items.map(itemPayload), { msl_revalidado: !skipCheck });
    try {
      if (!skipCheck) {
        await refreshItems();
        renderList(); if (state.summary) renderSummary();
        const out = state.items.filter((i) => i.soldOut);
        if (out.length) { openSoldOut(out); return; }
      }
      const items = state.items.map((i) => ({ id: i.variantId, quantity: i.qty, properties: { _product_type: i.type || 'Material' } }));
      const res = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      let data = {};
      try { data = await res.json(); } catch (e) { /* ignore */ }
      if (!res.ok) {
        console.warn('[MSL] /cart/add.js falhou', res.status, data);
        toast(data.description || data.message || 'Não foi possível adicionar à sacola.');
        track('msl_sacola_erro', { msl_erro: 'cart_add', msl_status: res.status, msl_mensagem: data.description || data.message || null });
        return;
      }
      let cart = null;
      try { cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); } catch (e) { /* ignore */ }
      if (cart && !cart.item_count) {
        console.warn('[MSL] carrinho voltou vazio após o add', cart);
        toast('A sacola voltou vazia. Tente novamente.');
        track('msl_sacola_erro', { msl_erro: 'carrinho_vazio' });
        return;
      }
      trackEcom('msl_sacola_sucesso', total(), state.items.map(itemPayload), {
        msl_itens_carrinho: cart ? cart.item_count : null
      });
      document.dispatchEvent(new CustomEvent('cart:item-added'));
      releaseScroll();
      closeList();
      if (OPEN_DRAWER && document.querySelector('cart-drawer')) {
        try { sessionStorage.setItem('msl_open_cart', '1'); } catch (e) { /* ignore */ }
        window.location.reload();
        return;
      }
      window.location.href = '/cart';
    } catch (e) {
      console.warn('[MSL] erro ao adicionar à sacola', e);
      toast('Não foi possível adicionar à sacola. Tente novamente.');
      track('msl_sacola_erro', { msl_erro: 'excecao', msl_mensagem: String(e && e.message || e) });
    } finally { btns.forEach((b) => { b.disabled = false; }); }
  }

  function openCartDrawer() {
    const d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return; }
    const icon = document.querySelector('#cart-icon-bubble');
    if (icon) icon.click(); else window.location.href = '/cart';
  }

  function openSoldOut(out) {
    trackEcom('msl_produto_esgotado', out.reduce((a, i) => a + i.price * i.qty, 0), out.map(itemPayload));
    const names = out.map((i) => `<li>${esc(i.title)}</li>`).join('');
    openCard(`
      <div class="msl-card__head"><h2 class="msl-card__title">${esc(T.soldOutTitle)}</h2></div>
      <p class="msl-card__text">${esc(T.soldOutText)}</p>
      <ul class="msl-check msl-check--bullets">${names}</ul>
      <div class="msl-btn-stack">
        <button type="button" class="msl-btn" data-msl-action="replace-out">${esc(T.soldOutReplace)}</button>
        <button type="button" class="msl-btn msl-btn--outline" data-msl-action="skip-out">${esc(T.soldOutSkip)}</button>
      </div>`, { locked: true });
  }
  function dropSoldOut() {
    state.items = state.items.filter((i) => !i.soldOut);
    save(); renderGrid(); renderList(); renderCatbar(); renderFabs();
  }

  // ---------- Init ----------
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-msl-open], a[href*="#monte-sua-lista"]');
    if (!a) return;
    e.preventDefault();
    const origem = a.classList.contains('msl-header-btn--mobile') ? 'header_mobile'
      : a.classList.contains('msl-header-btn--desktop') ? 'header_desktop'
      : 'link';
    track('msl_iniciar', { msl_origem: origem, msl_pagina: location.pathname });
    openStart();
  });

  // O fluxo da prefeitura tem saldo fixo da lista: nunca herda a chave persistida
  if (state.mode === 'city') {
    const l = currentList();
    if (l && Number(l.balance) > 0 && state.balance == null) setBalance(Number(l.balance));
  } else if (state.balance == null) {
    state.balance = readBarBalance();
  }
  if (state.mode === 'city' && !currentList()) { state.mode = null; state.items = []; state.pendingConfirm = false; resetBalance(); }

  if (onPage) {
    renderFabs(); renderStatus();
    if (!state.mode) {
      openStart();
    } else if (state.summary && state.items.length) {
      showSummary();
      refreshItems().then(() => { renderList(); renderSummary(); });
    } else {
      startMode().then(() => {
        if (state.pendingConfirm) { state.pendingConfirm = false; save(); openConfirm(); }
        refreshItems().then(() => { renderList(); renderGrid(); if (state.summary) renderSummary(); });
      });
    }
  }

  try {
    if (sessionStorage.getItem('msl_open_cart')) {
      sessionStorage.removeItem('msl_open_cart');
      window.addEventListener('load', () => setTimeout(openCartDrawer, 350));
    }
  } catch (e) { /* ignore */ }

  if (location.hash === '#montar' || new URLSearchParams(location.search).has('montar')) openStart();
})();